import { api } from '../api.js';
import { el, clear, fragment } from '../dom.js';
import { t } from '../i18n.js';
import { openSeriesForm } from './series-form.js';
import { renderCalendar } from './calendar.js';
import { seriesCard } from './series-list.js';

// The root of the workspace, and it belongs to the person.
//
// It was a switcher between institutions, which assumed the person is not a
// promoter — and since posting opened they are. Their own programme is here.
//
// **Institutions are not.** They live at /panel/i, behind their own door:
// somebody who posts the occasional thing of their own is not a venue and
// should not have to decide whether they are, which is what an empty
// "Institutionen" heading under their own programme asked every time they
// looked at it. The event form still offers them as hosts, because by then the
// person has one and the question is which — not whether.
export async function renderHome({ query }) {
  const accounts = await api.get('/accounts');
  const self = accounts.find((row) => row.isSelf);

  const list = el('ul', { class: 'card-list' });
  const notice = el('p', { class: 'cal-hint', role: 'status' });
  notice.hidden = true;

  let series = self ? await api.get(`/accounts/${self.id}/series`) : [];

  async function reload(message) {
    series = await api.get(`/accounts/${self.id}/series`);
    paint();
    // The month above the list, not only the list. Anything that changes what
    // exists — a delete, a publish, a pause, a shift — changes both.
    await calendar?.reload();
    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    }
  }

  function paint() {
    clear(list);
    if (series.length === 0) {
      list.append(el('li', {}, el('div', { class: 'pub-empty' }, t.ownProgrammeEmpty)));
      return;
    }
    for (const row of series) list.append(seriesCard(row, self.id, reload));
  }

  paint();

  const newEvent = el('button', { class: 'button', type: 'button' }, t.newEvent);
  newEvent.addEventListener('click', () => openSeriesForm({
    venueId: self.id, accounts, onSaved: reload,
  }));

  const calendar = self ? await renderCalendar({ accountId: self.id, query, basePath: '/panel' }) : null;

  return fragment([
    el('h1', { class: 'pub-title' }, t.ownProgramme),
    el('p', { class: 'pub-lede' }, t.ownProgrammeLede),
    el('p', { class: 'row' }, [newEvent]),
    notice,
    calendar,
    el('h2', { class: 'bucket-title' }, t.series),
    list,
  ]);
}
